// Markdown-style link support: [label](https://…)
export const MD_LINK = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
export const BARE_URL = /(https?:\/\/[^\s)]+)/g;

// Insert a [label](url) markdown link at the textarea/input cursor using window.prompt.
// Returns { value, caret } or null if cancelled.
export function insertLinkAtCursor(el) {
    const start = el.selectionStart ?? el.value.length;
    const end = el.selectionEnd ?? el.value.length;
    const selected = el.value.slice(start, end);
    let url = window.prompt("Enter the link URL (https://…)", "https://");
    if (!url) return null;
    url = url.trim();
    if (!url || url === "https://") return null;
    if (!/^https?:\/\//i.test(url)) url = "https://" + url;
    let label = selected || window.prompt("Link text to display", url) || url;
    const md = `[${label}](${url})`;
    const value = el.value.slice(0, start) + md + el.value.slice(end);
    return { value, caret: start + md.length };
}

// onKeyDown handler factory: Ctrl/Cmd+K inserts a link and calls setValue(newValue).
export function linkShortcut(setValue) {
    return (e) => {
        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
            e.preventDefault();
            const res = insertLinkAtCursor(e.currentTarget);
            if (res) setValue(res.value);
        }
    };
}
